// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PostReactivationFormPayloadRequestModel from '../../model/post-reactivation-form-payload-request-model';
import PostReactivationFormPayloadRequestDTO from '../dto/post-reactivation-form-payload-request-dto';
import dtoSchema from '../schemas/post-reactivation-form-payload-request-schema';

export default abstract class PostReactivationFormPayloadRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PostReactivationFormPayloadRequestDTO>) {
    super();
    this.contact = {};
    if (data) {
      this.contact = {
        isCompany: data['contact.IsCompany'],
        companyName: data['contact.CompanyName'],
        salutation: data['contact.Salutation'],
        firstName: data['contact.FirstName'],
        lastName: data['contact.LastName'],
        dateOfBirth: data['contact.DateOfBirth'],
        email: data['contact.EMail'],
        phoneNumber: data['contact.PhoneNumber'],
        mobilePhoneNumber: data['contact.MobilePhoneNumber'],
        companyPhone: data['contact.CompanyPhone'],
        street: data['contact.Street'],
        houseNumber: data['contact.HouseNumber'],
        addressLine1: data['contact.AddressLine1'],
        addressLine2: data['contact.AddressLine2'],
        pobox: data['contact.POBox'],
        postalCode: data['contact.PostalCode'],
        city: data['contact.City'],
        countryIso2: data['contact.CountryIso2'],
        website: data['contact.Website'],
      };
      this.donationItem = data.donationItem;
      this.message = data.message;
      this.contactId = data.contactId;
      this.newsletterItems = data.newsletterItems;
      this.characteristicItems = data.characteristicItems;
      this.languageIso2 = data.languageIso2;
      this.tenantKey = data.tenantKey;
    }
  }

  contact: {
    /**
    */
    isCompany?: boolean;
    /**
    */
    companyName?: string;
    /**
    * @type {int32}
    */
    salutation?: 0 | 1 | 2; // ContactSalutationTypeDTO
    /**
    */
    firstName?: string;
    /**
    */
    lastName?: string;
    /**
    * @type {date-time}
    */
    dateOfBirth?: string;
    /**
    */
    email?: string;
    /**
    */
    phoneNumber?: string;
    /**
    */
    mobilePhoneNumber?: string;
    /**
    */
    companyPhone?: string;
    /**
    */
    street?: string;
    /**
    */
    houseNumber?: string;
    /**
    */
    addressLine1?: string;
    /**
    */
    addressLine2?: string;
    /**
    */
    pobox?: string;
    /**
    */
    postalCode?: string;
    /**
    */
    city?: string;
    /**
    */
    countryIso2?: string;
    /**
    */
    website?: string;
  };

  /**
  */
  donationItem?: string;
  /**
  */
  message?: string;
  /**
  * @type {uuid}
  */
  contactId?: string;
  /**
  */
  newsletterItems?: string[];
  /**
  */
  characteristicItems?: string[];
  /**
  */
  languageIso2?: string;
  /**
  */
  tenantKey?: string;

  static toModel(dto: DeepPartial<PostReactivationFormPayloadRequestDTO>): PostReactivationFormPayloadRequestModel;
  static toModel(dto: DeepPartial<PostReactivationFormPayloadRequestDTO> | undefined | null): PostReactivationFormPayloadRequestModel | undefined;
  static toModel(dto: DeepPartial<PostReactivationFormPayloadRequestDTO> | undefined | null): PostReactivationFormPayloadRequestModel | undefined {
    return dto ? new PostReactivationFormPayloadRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PostReactivationFormPayloadRequestModel> | PostReactivationFormPayloadRequestModel): PostReactivationFormPayloadRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'contact.IsCompany': unwrapped.contact?.isCompany,
      'contact.CompanyName': unwrapped.contact?.companyName,
      'contact.Salutation': unwrapped.contact?.salutation,
      'contact.FirstName': unwrapped.contact?.firstName,
      'contact.LastName': unwrapped.contact?.lastName,
      'contact.DateOfBirth': unwrapped.contact?.dateOfBirth,
      'contact.EMail': unwrapped.contact?.email,
      'contact.PhoneNumber': unwrapped.contact?.phoneNumber,
      'contact.MobilePhoneNumber': unwrapped.contact?.mobilePhoneNumber,
      'contact.CompanyPhone': unwrapped.contact?.companyPhone,
      'contact.Street': unwrapped.contact?.street,
      'contact.HouseNumber': unwrapped.contact?.houseNumber,
      'contact.AddressLine1': unwrapped.contact?.addressLine1,
      'contact.AddressLine2': unwrapped.contact?.addressLine2,
      'contact.POBox': unwrapped.contact?.pobox,
      'contact.PostalCode': unwrapped.contact?.postalCode,
      'contact.City': unwrapped.contact?.city,
      'contact.CountryIso2': unwrapped.contact?.countryIso2,
      'contact.Website': unwrapped.contact?.website,
      donationItem: unwrapped.donationItem,
      message: unwrapped.message,
      contactId: unwrapped.contactId,
      newsletterItems: unwrapped.newsletterItems,
      characteristicItems: unwrapped.characteristicItems,
      languageIso2: unwrapped.languageIso2,
      tenantKey: unwrapped.tenantKey,
    } as PostReactivationFormPayloadRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PostReactivationFormPayloadRequestModel, can not map to PostReactivationFormPayloadRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
